import { HUB_WORK_ORDERS_BOOK_LIST } from "@bafe/validation";

/** Hub route segment (no leading slash). */
export const HUB_WORK_ORDERS_ROUTE = "work-orders";

export const WORK_ORDER_SINGULAR = "Work Order";
export const WORK_ORDER_PLURAL = "Work Orders";

export { HUB_WORK_ORDERS_BOOK_LIST };

export function hubWorkOrdersPath(search = ""): string {
	return `/hub/${HUB_WORK_ORDERS_ROUTE}${search}`;
}

export function hubWorkOrderOpenLink(id: number | string): string {
	return hubWorkOrdersPath(`?work=${id}`);
}

export function workOrdersFromBooks<T extends { id?: number }>(
	books: { workOrders?: T[]; work?: T[] },
): T[] {
	if (Array.isArray(books.workOrders)) return books.workOrders;
	if (Array.isArray(books.work)) return books.work;
	return [];
}
